import { AxiosResponse } from "axios";
import { Axios } from "../Axios";
import { TypeEmpresa } from "../../Models/Pessoa/Empresa";
import { useQuery } from "@tanstack/react-query";

export class EmpresaService {
    public listar(empresa: TypeEmpresa): Promise<AxiosResponse<TypeEmpresa[]>> {
        return Axios.post<TypeEmpresa[]>(`Empresa/listar`, empresa);
    }
    public inserir(empresa: TypeEmpresa){
        return Axios.post('Empresa/inserir', empresa);
    }

    public atualizar(empresa: TypeEmpresa){
        return Axios.put('Empresa/atualizar', empresa);
    }

    public ativar(codigoDaEmpresa: number){
        return Axios.patch(`Empresa/ativar/${codigoDaEmpresa}`);
    }

    public desativar(codigoDaEmpresa: number){
        return Axios.patch(`Empresa/desativar/${codigoDaEmpresa}`);
    }
}

export const useListar = (empresa: TypeEmpresa) => {
    return useQuery({
        queryKey: [`Empresa.listar`],
        queryFn: () => Axios.post<TypeEmpresa[]>(`Empresa/listar`, empresa).then(t => t.data),
        enabled: true
    })
}